<!-- 各常用预防性养护措施的属性分值范围Cij-->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form popoverWidth="680" :formConfig="advSearch" v-model="searchForm" @onSubmit="searchTable"></popover-form>
        </el-col>
        <el-col :span="20">
            <div class="text-align_right">
                <el-button type="primary" @click="addRow">新增</el-button>
            </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="goPageIndex"
          :pageCount="pageCount"
          @rowClick="rowClick($event)"
        ></dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
              <el-button-group>
                <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="dataSubmit" >保存</el-button>
                <el-button type="primary" @click="close">返回</el-button>
              </el-button-group>
          </div>
          <divider title="砂石路面预防性养护初选库明细" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="!(operationType==1||operationType==2)" v-model="form"></dynamic-form>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
      <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<script>
export default {
  name: "attributescores",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      initializeForm:{},
      showTabFom: false, //表格表单转换状态
      operationType: 1, //主表操作状态

      searchForm: {
        cause :'',/// 影响因素
        measure :'',/// 养护措施
      },
      advSearch: {
        list: [
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "100%",defaultValue: "",required: false,dataType: "string",pattern: "",placeholder: "",customClass: "",disabled: false,labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,showPassword: false,remoteFunc: "func_1573044806373"
            },
            name: "影响因素",
            novalid: {},
            key: "cause",
            model: "cause",
            rules: [{required: false,message: "必须填写"},{type: "string",message: "格式不正确"}]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": false,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "measure","label": "measure"},"remoteFunc": this.getMeasure,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用养护措施",
            "key": "适用养护措施",
            "model": "measure",
            "rules": [{required: false,message: "必须填写"}]
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      tableSet: {
        tableColumn: [
          {
            prop: "cause",
            label: "影响因素"
          },{
            prop: "measure",
            label: "养护措施"
          },{
            prop: "score",
            label: "分值"
          },{
            prop: "wi",
            label: "权重"
          },{
            prop: "remark",
            label: "备注"
          },
        ],
        tableColBtn: [
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
          show: true,
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.del
        }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      form: {
        rowCode :0,/// 主键int
        cause :'',/// 影响因素
        measure :'',/// 养护措施
        score :0,/// 分值    decimal
        wi :0,/// 权重    decimal
        remark :'',/// 备注
        createUser :'',
        createUserName :'',
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        status :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
      },
      formConfig: {
        list: [
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "100%",defaultValue: "",required: true,dataType: "string",pattern: "",placeholder: "",customClass: "",disabled: false,labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,showPassword: false,remoteFunc: "func_1573044806373"
            },
            name: "影响因素",
            novalid: {},
            key: "cause",
            model: "cause",
            rules: [{required: true,message: "必须填写"},{type: "string",message: "格式不正确"}]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": true,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "measure","label": "measure"},"remoteFunc": this.getMeasure,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用养护措施",
            "key": "适用养护措施",
            "model": "measure",
            "rules": [{required: true,message: "必须填写"}]
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "",required: true,defaultValue: 0,min: 0,max: 999999999,step: 0.01,disabled: false,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
            },
            name: "权重",
            novalid: {},
            key: "wi",
            model: "wi",
            rules: [{required: true,message: "必须填写"}]
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "",required: false,defaultValue: 0,min: 0,max: 999999999,step: 0.01,disabled: false,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
            },
            name: "分值",
            novalid: {},
            key: "score",
            model: "score",
            rules: [{required: false,message: "必须填写"}]
          },
          {
            "type": "textarea",
            "icon": "icon-diy-com-textarea",
            "options": {
              "width": "500px","defaultValue": "","required": false,"disabled": false,"pattern": "","placeholder": "","customClass": "",
              "labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteFunc": "func_1577068006527","remoteOption": "option_1577068006527"
            },
            "name": "备注",
            "key": "1577068006527",
            "model": "remark",
            "rules": []
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    /********字典获取 ******/
    getDiction(target, targets) {
        let name = target.form.key;
        this.$http.post(this.$url.getDict, { search: name }).then(res => {
            let { data } = res;
            target.setList(data);
        });
    },
    getMeasure(target, targets){
      this.$http.post(this.$url.routeDecision.getpmmeasurefs, { pageSize: 9999999,pageIndex:1 }).then(res => {
          let { data } = res;
          target.setList(data);
      });
    },
    /*******获取表格数据*****/
    getTableData() {//获取表格数据
        let that = this;
        this.$http.postHandle('',this.$url.routeDecision.getattributescores, { ...that.searchForm, pageIndex:this.pageIndex, pageSize:this.pageSize }).then(res => {
            this.tableData = res.data;
            this.pageCount = res.pageCount;
        });
    },
    addRow() {//新增
      this.showTabFom = true;
      this.operationType = 1;
      this.resetForm("form");
    },
    searchTable(){//查询
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getTableData();
    },
    goPageIndex(pageIndex,pageSize) {//分页
      this.pageIndex = pageIndex;
      this.pageSize = pageSize
      this.getTableData();
    },
    rowClick(row) {//查看
        this.operationType = 3;
        this.form = this.$formSetForm(this.form,row);
        this.showTabFom = true;
    },
    edit(row, index) {//编辑
        this.operationType = 2;
        this.form = this.$formSetForm(this.form,row);
        this.showTabFom = true;
    },
    del(row, index) {//删除
      let form = row;
      this.$msgDel(this.$url.routeDecision.operationattributescore, { attributeScore: form, operationType: 8 }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.getTableData();
      });
    },
    dataSubmit() {//保存
        this.$refs.form.submit().then(res => {
            let form = this.$formSetForm(this.form, this.form);
            this.$http.postHandle("保存", this.$url.routeDecision.operationattributescore, { attributeScore: form, operationType: this.operationType }).then(res => {
                this.showTabFom = false;
                this.getTableData();
            });
        });
    },
    close() {//返回
      this.$closePage(this.operationType).then(() => {
        this.showTabFom = false;
        this.getTableData();
      });
    },
    resetForm(formName) {//重置
      let that = this;
      this.form = this.$formSetForm(this.initializeForm , this.initializeForm)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTableData();
    this.initializeForm = this.$formSetForm(this.form , this.form)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/attributescores.vue"
}
</vue-filename-injector>
